import React from "react";
import { Check, Search, UserCircle2, Building, Briefcase, MapPin, Globe } from "lucide-react";

const FILTER_OPTIONS = [
  {
    key: "all",
    label: "All",
    icon: Search,
  },
  {
    key: "organizations",
    label: "Hosts",
    icon: UserCircle2,
  },
  {
    key: "buildings",
    label: "Buildings",
    icon: Building,
  },
  {
    key: "spaces",
    label: "Space names",
    icon: Briefcase,
  },
  {
    key: "cities",
    label: "Cities",
    icon: MapPin,
  },
  {
    key: "countries",
    label: "Countries",
    icon: Globe,
  },
];

const SearchSpacesDialog = ({ searchFilter, onSearchFilterChange }) => {
  return (
    <div className="py-1">
      {FILTER_OPTIONS.map(option => {
        const Icon = option.icon;
        const isActive = searchFilter === option.key;

        return (
          <button
            key={option.key}
            onClick={() => onSearchFilterChange(option.key)}
            className={`w-full flex items-center gap-3 px-3 py-2 text-left hover:bg-gray-50 transition-colors ${
              isActive ? "bg-blue-50" : ""
            }`}
          >
            <div className={`${isActive ? "text-blue-600" : "text-gray-500"}`}>
              <Icon className="h-4 w-4" />
            </div>
            <div className="flex-1 min-w-0">
              <div className={`${isActive ? "text-blue-600" : "text-gray-900"}`}>{option.label}</div>
            </div>
            {isActive && <Check className="h-4 w-4 text-blue-600 flex-shrink-0" />}
          </button>
        );
      })}
    </div>
  );
};

export default SearchSpacesDialog;
